import { Expose } from "class-transformer";
import { Site } from "./tkt-site";

export class FacilityLocationMap {
  @Expose() businessId: string;
  @Expose() placemarkName: string;
  @Expose() unitArea: number;
  @Expose() latitude: string;
  @Expose() longitude: string;
  @Expose() siteId: string;
  @Expose() areaId?: string;
  @Expose() parentID?:string;
  @Expose() ManagerId?:string;
}
export class Attachment {
  @Expose() id: string;
  @Expose() path: string;
}


export class CreateFacilityLocationMap{
  @Expose() BusinessId: string;
  @Expose() PlacemarkName: string;
  @Expose() UnitArea: number;
  @Expose() Latitude: string;
  @Expose() Longitude: string;
  @Expose() FacilityLocationMapSettings: string;
  @Expose() FacilityID: string;
  @Expose() LocationID: string;
  @Expose() AreaID: string;
}


export class UpdateFacilityLocationMap{
  @Expose() BusinessId: string;
  @Expose() Id:string;
  @Expose() PlacemarkName: string;
  @Expose() UnitArea: number;
  @Expose() Latitude: string;
  @Expose() Longitude: string;
  @Expose() FacilityLocationMapSettings: string;
  @Expose() FacilityID: string;
  @Expose() LocationID: string;
  @Expose() AreaID: string;
}
